import { render, staticRenderFns } from "./DownloadedDetail.vue?vue&type=template&id=4320a0a3&scoped=true&"
import script from "./DownloadedDetail.vue?vue&type=script&lang=js&"
export * from "./DownloadedDetail.vue?vue&type=script&lang=js&"
import style0 from "./DownloadedDetail.vue?vue&type=style&index=0&id=4320a0a3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4320a0a3",
  null
  
)

export default component.exports